export default class AEditor {
    constructor(editor) {
        this.editor = editor;
    }

    setEditor(editor) {
        this.editor = editor;
    }

    getSelection() {
        if (typeof this.editor.getSelection != "undefined") {
            return this.editor.getSelection();
        } else {
            return this.editor.selection().text;
        }
    }

    replaceSelection(text) {
        let needPopup = true;
        if (typeof this.editor !== "undefined") {
            if (typeof this.editor.replaceSelectionText === "function") {
                this.editor.replaceSelectionText(text);
                needPopup = false;
            } else if (typeof this.editor.replaceSelection === "function") {
                this.editor.replaceSelection(text);
                needPopup = false;
            } else if (typeof this.editor.insertAtCursor === "function") {
                this.editor.insertAtCursor(text);
                needPopup = false;
            } else if (typeof this.editor.updateValue === "function") {
                this.editor.updateValue(text);
                needPopup = false;
            } else if (typeof this.editor.setContent === "function") {
                this.editor.setContent(text, true);
                needPopup = false;
            }
        }
        if (needPopup) {
            window.AccessoriesPro.utils._popup({
                title: '不支持你的编辑器',
                innerHtml: `<div class="params">
                <div class="input-group"><label>请手动复制以下内容</label><input type="text" readonly value="${text}" /><span class="x-btn x-btn-primary copy">${window.AConf.i18n.operate.copy}</span></div>
                </div>`,
                handler: () => {
                    $('.x-modal-body .params .x-btn.copy').click(function () {
                        var input = $(this).parent().find('input').eq(0);
                        input.attr("readonly", false);
                        input.select();
                        if (document.execCommand('copy')) {
                            _this._notice(_this.text.status.copySuccess, "success");
                        } else {
                            _this._notice(_this.text.status.copyFailed, "error");
                        }
                        input.blur();
                        input.attr("readonly", true);
                    });
                }
            });
        }
    }
}